export default __webpack_public_path__ + "static/media/evaluate-your-experiment.0f2985d6.svg";